import HeroImg from "../home/hero/image";
import Aos from "../aos/aos";
import { FaUser, FaUserTie, FaBirthdayCake,FaMapMarkerAlt, FaPhone, FaFlag,} from "react-icons/fa";
import { AiOutlineMail} from "react-icons/ai";
const Abouthero = () => {
    Aos(2000)
    return (
        <div className="flex flex-col md:flex-row space-y-4  bg-black/30 rounded-lg md:space-x-8 md:space-y-0 w-full h-[600px]  md:h-[550px]">

            <div className="md:h-full md:ml-8 h-[50%] flex flex-col items-center justify-center space-y-2 w-full md:w-[50%] py-2 px-2">
                <div className="flex w-full text-xl " data-aos="zoom-in-up">
                    <div className="w-[40%] text-white flex space-x-1"><FaUser className="text-yellow-500" size={20} /> <div>Name</div></div>
                    <div className="w-[60%] text-yellow-500 font-bold font-mono">:Otsu Udoka</div>
                </div>
                <div className="flex w-full text-xl " data-aos="zoom-in-down">
                    <div className="w-[40%] text-white flex space-x-1"><FaUserTie className="text-yellow-500" size={20} /> <div>Profession</div></div>
                    <div className="w-[60%] text-yellow-500 font-bold font-mono">:Web Developer</div>
                </div>
                <div className="flex w-full text-xl " data-aos="zoom-in-up">
                    <div className="w-[40%] text-white flex space-x-1"><FaBirthdayCake className="text-yellow-500" size={20} /> <div>Birthday</div></div>
                    <div className="w-[60%] text-yellow-500 font-bold font-mono">:June 8, 1996</div>
                </div>
                
                <div className="flex w-full text-xl " data-aos="zoom-in-down">
                    <div className="w-[40%] text-white flex space-x-1"><FaMapMarkerAlt className="text-yellow-500" size={20} /> <div>Address</div></div>
                    <div className="w-[60%] text-yellow-500 font-bold font-mono">:Abakaliki</div>
                </div>
                <div className="flex w-full text-xl " data-aos="zoom-in-up">
                    <div className="w-[40%] text-white flex space-x-1"><FaFlag className="text-yellow-500" size={20} /> <div>Nationality</div></div>
                    <div className="w-[60%] text-yellow-500 font-bold font-mono">:Nigerian</div>
                </div>
            </div>
            <HeroImg />


        </div>
    );
}

export default Abouthero;